// 접속 기기가 모바일(Phone, Tablet)인지 확인하는 함수
const checkMobileDevice = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // 모바일 기기 키워드가 포함되어 있는지 검사
  return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
};


const isMobile = checkMobileDevice();

export const getToxicityColor = (score) => {
  if (score > 0.7) return '#ff4e50'; // 위험 (레드)
  if (score > 0.4) return '#ffd700'; // 주의 (골드)
  return '#00d4ff'; // 청정 (블루)
};

export const styles = {
  container: { backgroundColor: '#0a0a0a', color: '#fff', minHeight: '100vh', padding: '40px 20px 120px 20px', fontFamily: "'Noto Sans KR', sans-serif" },
  loading: { color: '#00d4ff', textAlign: 'center', marginTop: '100px', fontSize: '1.2rem' },
  title: { textAlign: 'center', fontSize: '2.2rem', fontWeight: '900', marginBottom: '20px' },
  
  factionSelector: {
    position: 'relative',
    textAlign: 'center', 
    padding: '30px',
    background: '#161616', 
    border: '1px solid #333', 
    borderRadius: '8px', 
    marginBottom: '30px' 
  },
  
  factionStatus: { textAlign: 'center', marginBottom: '20px', fontSize: '1.1rem', color: '#888' },
  joinBlue: { background: '#00d4ff', color: '#000', border: 'none', padding: '10px 20px', marginRight: '10px', cursor: 'pointer', fontWeight: 'bold', borderRadius: '4px' },
  joinRed: { background: '#ff4e50', color: '#fff', border: 'none', padding: '10px 20px', cursor: 'pointer', fontWeight: 'bold', borderRadius: '4px' },
  resetBtn: { marginLeft: '15px', background: 'transparent', border: '1px solid #444', color: '#666', fontSize: '0.8rem', cursor: 'pointer' },
  blueText: { color: '#00d4ff', fontWeight: 'bold' },
  redText: { color: '#ff4e50', fontWeight: 'bold' },
  gaugeContainer: { maxWidth: '1000px', margin: '0 auto 40px auto', minHeight: '80px' },
  gaugeLabel: { display: 'flex', justifyContent: 'space-between', marginBottom: '10px' },
  gaugeBarTrack: { width: '100%', height: '15px', display: 'flex', background: '#1a1a1a', borderRadius: '10px', overflow: 'hidden' },
  gaugeBarBlue: { backgroundColor: '#00d4ff', transition: 'width 1s ease' },
  gaugeBarRed: { backgroundColor: '#ff4e50', transition: 'width 1s ease' },
  
  feedWrapper: { position: 'relative', display: 'flex', maxWidth: '1200px', margin: '0 auto', minHeight: '600px' },
  
  centerLine: { position: 'absolute', left: '50%', top: 0, bottom: 0, width: '1px', background: '#333', transform: 'translateX(-50%)' },
  factionFeed: isMobile ?
   { 
    flex: 1, 
    // 🚩 모바일일 때만 비대칭 패딩 적용, 웹에서는 기존 20px 유지
    padding: isMobile ? '0 2px 0 8px' : '0 20px', 
    minWidth: isMobile ? 0 : undefined,
    display: isMobile ? 'flex' : undefined,
    flexDirection: isMobile ? 'column' : undefined,
    alignItems: isMobile ? 'stretch' : undefined
   }
   : { flex: 1, padding: '0 20px' },
  
  blueHeader: { color: '#00d4ff', textAlign: 'right', marginBottom: '20px' },
  redHeader: { color: '#ff4e50', textAlign: 'left', marginBottom: '20px' },
  
  postCard: isMobile ? 
   { 
    background: '#161616', 
    // 🚩 모바일일 때만 패딩을 줄임
    padding: isMobile ? '8px' : '15px', 
    marginBottom: '15px', 
    cursor: 'pointer',
    width: isMobile ? '100%' : undefined,
    boxSizing: isMobile ? 'border-box' : undefined
   }
   : { background: '#161616', padding: '15px', marginBottom: '15px', cursor: 'pointer' },



  postContent: { margin: 0, color: '#ccc', lineHeight: '1.5' },
  likeSection: { display: 'flex', gap: '10px', marginTop: '10px' },
  deleteBtn: {
    marginLeft: 'auto', // 삭제 버튼을 오른쪽 끝으로 밀어냄
    background: 'transparent',
    border: '1px solid #444',
    color: '#ff4e50',
    padding: '4px 8px',
    borderRadius: '4px',
    fontSize: '0.75rem',
    cursor: 'pointer',
    opacity: 0.7,
    transition: '0.2s'
  },
  likeBtn: { background: 'transparent', border: '1px solid #333', padding: '5px 10px', cursor: 'pointer', borderRadius: '4px' },
  inputDock: { position: 'fixed', bottom: 0, left: 0, width: '100%', padding: '20px', background: 'rgba(10,10,10,0.95)', borderTop: '1px solid #333' },
  inputInner: { maxWidth: '800px', margin: '0 auto', display: 'flex', gap: '10px' },
  textarea: { flex: 1, height: '50px', background: '#000', border: '1px solid #333', color: '#fff', padding: '10px', resize: 'none' },
  postBtn: { background: '#00d4ff', color: '#000', border: 'none', padding: '0 20px', fontWeight: 'bold', cursor: 'pointer' },

  // 모달 및 댓글 스타일 추가
  modalOverlay: { position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(0,0,0,0.85)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 100 },
  modalContent: { background: '#111', width: '90%', maxWidth: '600px', maxHeight: '80vh', borderRadius: '12px', display: 'flex', flexDirection: 'column', border: '1px solid #333', overflow: 'hidden' },
  modalHeader: { padding: '15px 20px', borderBottom: '1px solid #222', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#161616' },
  closeBtn: { background: 'transparent', border: 'none', color: '#fff', fontSize: '1.2rem', cursor: 'pointer' },
  modalBody: { padding: '0 20px 20px 20px', overflowY: 'auto' },
  selectedContent: { fontSize: '1.1rem', lineHeight: '1.6', color: '#ddd', whiteSpace: 'pre-wrap' },
  divider: { border: 'none', height: '1px', background: '#333', margin: '20px 0' },
  commentContainer: { marginTop: '10px' },
  commentTitle: { fontSize: '1rem', marginBottom: '15px', color: '#888' },
  commentList: { display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '20px' },
  commentItem: { padding: '10px', background: '#0a0a0a', borderRadius: '4px' },
  commentContent: { fontSize: '0.9rem', color: '#ccc', margin: 0 },
  commentInputWrapper: { display: 'flex', gap: '8px' },
  commentInput: { flex: 1, background: '#000', border: '1px solid #333', color: '#fff', padding: '10px', borderRadius: '4px' },
  commentBtn: { background: '#333', color: '#fff', border: 'none', padding: '0 15px', borderRadius: '4px', cursor: 'pointer' },

  // [추가] 댓글용 박스형 삭제 버튼 스타일
  commentDeleteBtn: {
    background: 'transparent',
    border: '1px solid #444',
    color: '#ff4e50',
    padding: '2px 8px', // 댓글 크기에 맞게 패딩 조절
    borderRadius: '4px',
    fontSize: '0.7rem',
    cursor: 'pointer',
    opacity: 0.7,
    transition: '0.2s',
    marginLeft: 'auto', // 오른쪽 끝으로 밀기
  },
  
  // 댓글 액션들을 담는 컨테이너 (정렬용)
  commentActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginTop: '8px'
  },

  // 신고 관련 스타일 추가
  reportBtn: {
    background: 'transparent',
    border: 'none',
    color: '#aaa',
    fontSize: '0.75rem',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    padding: '2px 5px',
    borderRadius: '4px',
    transition: '0.2s',
    marginLeft: '5px',
    fontWeight: 'bold'
  },

  reportModalOverlay: {
    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
    background: 'rgba(0,0,0,0.8)', display: 'flex', justifyContent: 'center',
    alignItems: 'center', zIndex: 2000
  },

  reportModalContent: {
    background: '#1a1a1a', padding: '25px', borderRadius: '12px',
    width: '320px', textAlign: 'center', border: '1px solid #333'
  },

  reasonList: { listStyle: 'none', padding: 0, margin: '20px 0', textAlign: 'left' },
  reasonItem: {
    padding: '12px', borderBottom: '1px solid #222', cursor: 'pointer',
    color: '#ccc', fontSize: '0.9rem', transition: '0.2s'
  },
  
  cancelBtn: {
    marginTop: '10px', background: 'transparent', border: 'none', color: '#888', cursor: 'pointer'
  },

  adminWrapper: { maxWidth: '1000px', margin: '0 auto', padding: '20px' },
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px', marginBottom: '40px' },
  statCard: { background: '#161616', padding: '20px', borderRadius: '8px', textAlign: 'center', border: '1px solid #333' },
  reportTable: { width: '100%', borderCollapse: 'collapse', marginTop: '20px', background: '#111' },
  th: { padding: '12px', borderBottom: '2px solid #333', color: '#888', textAlign: 'left' },
  td: { padding: '12px', borderBottom: '1px solid #222', color: '#ccc', fontSize: '0.9rem' },
  actionButtons: { display: 'flex', gap: '8px' },
  approveBtn: { background: '#ff4e50', color: '#fff', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer' },
  rejectBtn: { background: '#00d4ff', color: '#000', border: 'none', padding: '5px 10px', borderRadius: '4px', cursor: 'pointer' },

  topicListContainer: {
    maxWidth: '1000px',
    margin: '0 auto',
    padding: '40px 20px',
    minHeight: '80vh'
  },
  heroSection: {
    textAlign: 'center',
    marginBottom: '60px',
    borderBottom: '1px solid #222',
    paddingBottom: '40px',
    position: 'relative'
  },
  heroTitle: {
    fontSize: isMobile ? '1.8rem' : '2.8rem',
    fontWeight: '900',
    color: '#fff',
    letterSpacing: '-1px',
    marginBottom: '15px'
  },
  heroSub: {
    color: '#888',
    fontSize: isMobile ? '0.9rem' : '1.1rem',
    letterSpacing: '1px'
  },
  topicGrid: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
    gap: '25px'
  },
  topicCard: {
    background: '#161616',
    border: '1px solid #333',
    padding: '30px',
    borderRadius: '4px',
    transition: '0.3s ease',
    position: 'relative',
    overflow: 'hidden',
    cursor: 'pointer',
    minHeight: '320px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },

  topicCardHover: {
    borderColor: '#00d4ff',
    boxShadow: '0 0 20px rgba(0, 212, 255, 0.1)'
  },
  topicTitle: {
    fontSize: '1.4rem',
    fontWeight: 'bold',
    marginBottom: '15px',
    color: '#fff'
  },
  topicFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '20px'
  },
  enterBtn: {
    background: 'transparent',
    border: '1px solid #00d4ff',
    color: '#00d4ff',
    padding: '8px 20px',
    fontWeight: 'bold',
    cursor: 'pointer',
    borderRadius: '2px',
    fontSize: '0.9rem'
  },
  adminActionRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '30px'
  },
  createTopicBtn: {
    background: '#00d4ff',
    color: '#000',
    border: 'none',
    padding: '12px 25px',
    fontWeight: '900',
    cursor: 'pointer',
    borderRadius: '2px',
    fontSize: '1rem',
    boxShadow: '0 4px 15px rgba(0, 212, 255, 0.3)'
  },

  rulesOverlay: {
    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
    background: 'rgba(0,0,0,0.9)', display: 'flex', justifyContent: 'center',
    alignItems: 'center', zIndex: 3000, padding: '20px'
  },
  rulesContent: {
    background: '#111', width: '100%', maxWidth: '800px', maxHeight: '85vh',
    borderRadius: '8px', border: '1px solid #333', display: 'flex',
    flexDirection: 'column', overflow: 'hidden', boxShadow: '0 0 40px rgba(0,0,0,0.5)'
  },
  rulesBody: {
    padding: '30px', overflowY: 'auto', color: '#ccc', lineHeight: '1.7'
  },
  rulesSection: { marginBottom: '30px' },
  rulesSectionTitle: { 
    color: '#00d4ff', fontSize: '1.2rem', fontWeight: 'bold', 
    marginBottom: '15px', borderLeft: '4px solid #00d4ff', paddingLeft: '12px' 
  },
  rulesTable: {
    width: '100%', borderCollapse: 'collapse', margin: '15px 0', background: '#0a0a0a'
  },
  rulesTableTd: {
    padding: '10px', border: '1px solid #222', fontSize: '0.9rem'
  },
  important: { color: '#ff4e50', fontWeight: 'bold' },

  sortContainer: {
    textAlign: 'right',
    maxWidth: '1200px',
    margin: '0 auto 15px auto',
    padding: '0 20px'
  },
  sortSelect: {
    background: '#111',
    color: '#00d4ff',
    border: '1px solid #333',
    padding: '8px 12px',
    borderRadius: '4px',
    fontSize: '0.85rem',
    cursor: 'pointer',
    outline: 'none',
    fontWeight: 'bold'
  },

  factionCloseBtn: {
  position: 'absolute',
  top: '12px',
  right: '15px',
  background: 'none',
  border: 'none',
  color: '#666',
  fontSize: '1.2rem',
  cursor: 'pointer',
  transition: '0.2s',
  padding: '5px',
  lineHeight: '1',
  zIndex: 10
  },

  toxicityBadge: {
    fontSize: '0.7rem',
    marginLeft: '8px',
    padding: '2px 6px',
    borderRadius: '4px',
    background: 'rgba(0,0,0,0.3)', // 살짝 어두운 배경
    fontWeight: 'bold',
    border: '1px solid rgba(255,255,255,0.1)'
  }

};
